import { motion } from 'framer-motion'
import { FaUtensils, FaInstagram, FaWhatsapp } from 'react-icons/fa'
import { Link } from 'react-scroll'
import { navItems } from '..'

const Footer = () => {
  return (
          <footer className={`relative py-16 bg-gradient-to-r from-orange-400  to-orange-400 text-white overflow-hidden bg-orange-500/20 backdrop-blur-md md:bg-transparent md:backdrop-blur-none md:py-6`}>
        {/* Background Elements */}
        <div className="absolute inset-0 overflow-hidden">
          {/* Static decoration - removed continuous rotation for performance */}
          <div className="absolute -top-20 -right-20 w-40 h-40 rounded-full opacity-20" />
        </div>

        <div className="max-w-7xl mx-auto px-6 relative">
          <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
            {/* Brand Section */}
            <div className="lg:col-span-2 px-6 md:px-10">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="mb-6"
              >
                <div className="flex items-center space-x-3 mb-6">
                  <div className="relative">
                    <img
                      src="/images/Dineai.ico"
                      alt="Dine.AI logo"
                      className="w-16 h-16 rounded-xl "
                    />
                  </div>
                  <span className="text-3xl font-bold uppercase bg-white bg-clip-text text-transparent">
                    Dine.AI
                  </span>
                </div>
                <p className="text-white text-lg leading-relaxed max-w-md">
                  Transform your restaurant with beautiful digital menus powered by AI.
                  Join thousands of restaurants already growing with our platform.
                </p>

              </motion.div>
            </div>

            {/* Quick Links */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
            >
              <h4 className="font-bold text-xl mb-6 flex items-center gap-2">
                <FaUtensils className="text-white" />
                Quick Links
              </h4>
              <ul className="space-y-3">
                {navItems.map((item) => (
                  <li key={item.name}>
                    <Link
                      to={item.to}
                      smooth={true}
                      duration={800}
                      offset={-70}
                      className="text-white  transition-colors duration-300 cursor-pointer flex items-center gap-2 group"
                    >
                      <span className="w-1 h-1 bg-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </motion.div>

            {/* Connect Section */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
            >
              <h4 className="font-bold text-xl mb-6 flex items-center gap-2">

                Connect
              </h4>
              <div className="space-y-4">
                <div className="flex space-x-4">
                  <motion.a
                    href="https://www.instagram.com/nawaahorg/"
                    whileHover={{ scale: 1.1, rotate: 5 }}
                    whileTap={{ scale: 0.95 }}
                    className="group w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center border border-white/30 hover:border-white hover:bg-white/30 transition-all duration-300 shadow-lg hover:shadow-xl"
                  >
                    <FaInstagram className="text-white group-hover:text-pink-100 transition-colors duration-300" size={20} />
                  </motion.a>
                  <motion.a
                    href="https://wa.me/9613364257"
                    whileHover={{ scale: 1.1, rotate: -5 }}
                    whileTap={{ scale: 0.95 }}
                    className="group w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center border border-white/30 hover:border-white hover:bg-white/30 transition-all duration-300 shadow-lg hover:shadow-xl"
                  >
                    <FaWhatsapp className="text-white group-hover:text-green-100 transition-colors duration-300" size={20} />
                  </motion.a>
                </div>


              </div>
            </motion.div>
          </div>

          {/* Bottom Section */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
            className="flex flex-col md:flex-row justify-between items-center border-t border-white mt-12 pt-8 gap-4"
          >
            <div className="text-white text-center md:text-left">
              <p>&copy; {new Date().getFullYear()} Dina.ai - All Rights Reserved</p>
            </div>

            <motion.div
              whileHover={{ scale: 1.05 }}
              className="flex items-center gap-3 px-4 py-2"
            >
              <span className="text-white font-medium">Powered by</span>
              <div className="flex items-center ">

                <img
                  src="/images/Nawaah_logo.png"
                  className="w-20 brightness-0 invert"
                  alt="Nawaah logo"
                />
              </div>
            </motion.div>
          </motion.div>
        </div>
      </footer>
  )
}

export default Footer